import { CAR_SEARCH_FETCHED } from '../../actions/car';

export default function totalResultsPerSupplier(state = {}, action) {
  const newState = Object.assign({}, state);

  switch (action.type) {
    case CAR_SEARCH_FETCHED:
      newState[action.searchId] = action.availableResultsPerSupplier;
      return newState;

    default:
      return state;
  }
}
